import { FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { DownArrowIcon } from 'assets/icons';
import { t } from 'i18next';
import { FC, InputHTMLAttributes, useEffect, useState } from 'react';
import CustomDialog from 'shared/components/dialog/dialog';
import { getNumOfCombinations } from 'shared/util/utility';

interface Props {
	selectedCombination: string;
	handleSelectedCombination: (e: React.FormEvent<HTMLInputElement>) => void;
	numOfSlipsWithGroups: number;
	bankerCount: number;
}

const ChangeSystemCombination: FC<Props> = (props) => {
	const { selectedCombination, handleSelectedCombination, numOfSlipsWithGroups, bankerCount } = props;
	const [showDialog, setShowDialog] = useState(false);

	const numOfCombinationsAllowed = numOfSlipsWithGroups <= 12 ? numOfSlipsWithGroups - 1 : 1;

	useEffect(() => {
		if (numOfCombinationsAllowed === 1 && selectedCombination !== '1') {
			handleSelectedCombination({ currentTarget: { value: '1' } } as React.FormEvent<HTMLInputElement>);
		}
	}, [numOfCombinationsAllowed, handleSelectedCombination, selectedCombination]);

	return (
		<>
			<div onClick={() => setShowDialog(true)} className="changeSystemCombination" data-cy="betslip-combination">
				<span>
					{`${props.selectedCombination} z ${numOfSlipsWithGroups} ( ${t('Combinations')}: ${getNumOfCombinations(
						numOfSlipsWithGroups,
						parseInt(props.selectedCombination),
					)}) ${bankerCount > 0 ? `+${bankerCount}p` : ''}`}
				</span>
				<DownArrowIcon className="fill--primary width--12" />
			</div>
			{showDialog && (
				<CustomDialog open={showDialog} hideActionBtns={true} hideHeader className="radio-modal" onClose={() => setShowDialog(false)}>
					<div className="flex flex--column align__items--center justify__content--end width--full">
						<FormControl component="fieldset" className="field-options">
							<RadioGroup
								aria-label="changeCombinations"
								name="changeCombinations"
								value={selectedCombination}
								onChange={(e) => {
									handleSelectedCombination(e);
									setShowDialog(false);
								}}
								data-cy="betslip-change-combinations"
							>
								{[...Array(numOfCombinationsAllowed)].map((item, index) => (
									<FormControlLabel
										key={`${index}${item}`}
										className="customeRadio"
										value={`${index + 1}`}
										control={
											<Radio
												inputProps={{ 'data-cy': 'betslip-change-combinations' } as InputHTMLAttributes<HTMLInputElement>}
											/>
										}
										label={`${index + 1} z ${numOfSlipsWithGroups} ( ${t('Combinations')}: ${getNumOfCombinations(
											numOfSlipsWithGroups,
											index + 1,
										)}) ${bankerCount > 0 ? `+${bankerCount}p` : ''}`}
										labelPlacement="start"
									/>
								))}
							</RadioGroup>
						</FormControl>
					</div>
				</CustomDialog>
			)}
		</>
	);
};

export default ChangeSystemCombination;
